import fetch from 'logic/rest/FetchProvider';
import { reportingUrl } from 'report/Constants';
import type { CreateReportRequest } from 'report/types';

export default (id: string, report: CreateReportRequest) => fetch(id ? 'PUT' : 'POST', reportingUrl(id), report);
